/** Menüpunkte der Kopfzeile: ein-/ausblenden (settings.nav_hidden), Reihenfolge (settings.nav_order) und eigene Links (settings.nav_custom). */
export const NAV_ITEMS = [
  { key: "home", path: "nav.home" },
  { key: "properties", path: "nav.properties" },
  { key: "islands", path: "nav.islands" },
  { key: "tips", path: "nav.tips" },
  { key: "about", path: "nav.about" },
  { key: "contact", path: "nav.contact" },
  { key: "deals", path: "nav.deals" },
  { key: "wishlist", path: null, label: "Merkliste (Herz-Symbol)" },
  { key: "customer", path: "nav.customer" },
  { key: "landlord", path: "nav.landlord" },
];

// Hauptmenü (sortierbar, eigene Links möglich) vs. feste Aktionen rechts (Merkliste, Meine Buchungen, Vermieter)
export const NAV_MAIN_KEYS = ["home", "properties", "islands", "tips", "about", "contact", "deals"];
export const NAV_RIGHT_KEYS = ["wishlist", "customer", "landlord"];
export const customKey = (c) => `custom:${c.id}`;

export const navKeyOf = (path) => NAV_ITEMS.find((i) => i.path === path)?.key || null;

export const navVisible = (site) => { const h = new Set(site?.nav_hidden || []); return (key) => !h.has(key); };

/** Geordnete Hauptmenü-Einträge [{key, custom}] – gespeicherte Reihenfolge zuerst, neue/unbekannte Einträge hinten; mit `lang` nur eigene Links, die in dieser Sprache angezeigt werden sollen (custom.langs leer = alle). */
export const navMainOrder = (site, lang = null) => {
  const customs = (site?.nav_custom || []).filter((c) => c && c.id && (!lang || !c.langs?.length || c.langs.includes(lang)));
  const byKey = Object.fromEntries(customs.map((c) => [customKey(c), c]));
  const base = [...NAV_MAIN_KEYS, ...customs.map(customKey)];
  const order = (site?.nav_order || []).filter((k) => base.includes(k));
  return [...order, ...base.filter((k) => !order.includes(k))].map((key) => ({ key, custom: byKey[key] || null }));
};
